import Medium from "../utils/services/mediumService";
import listTemplate from "../templates/listTemplate";
import i18n from "../../plugins/i18n";

let list = listTemplate(Medium);

const state = {
  ...list.state
};
const getters = {
  ...list.getters
};
const actions = {
  ...list.actions,
  getList: function(state, { params = {}, onSuccess = () => {} }) {
    params = {
      locale: i18n.locale,
      ...params
    };
    list.actions.getList(state, { params, onSuccess });
  }
};

const mutations = {
  ...list.mutations
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
